import CollectionTypes from '../flux/reports/CollectionTypes';

const {
  COLLECTION_TYPE_SEASONAL,
  COLLECTION_TYPE_TIMELESS
} = CollectionTypes;

export default function collectionTypeToParentType(collectionType) {
  const map = {
    [COLLECTION_TYPE_SEASONAL]: 'collections',
    [COLLECTION_TYPE_TIMELESS]: 'categories',
  };

  return map[collectionType];
}
